import { Amplify, Auth } from "aws-amplify";
import { COGNITO_CONFIG } from "./AppConfig";

class AuthService {
  static async isAuth() {
    const result = await Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user);
        return true;
      })
      .catch((e) => {
        console.log(e);
        return false;
      });

    return result;
  }
  static async signUp(username, email, password) {
    try {
      const result = await Auth.signUp({
        username,
        password,
        attributes: {
          email,
        },
      });
      return result;
    } catch (error) {
      console.error("Error signing up:", error);
      throw error;
    }
  }

  static async confirmSignUp(username, code) {
    try {
      const result = await Auth.confirmSignUp(username, code);
      return result;
    } catch (error) {
      console.error("Error confirming sign up:", error);
      throw error;
    }
  }

  static async signIn() {
    try {
      const user = await Auth.federatedSignIn();
      return user;
    } catch (error) {
      console.error("Error signing in:", error);
      throw error;
    }
  }

  static async logout() {
    try {
      await Auth.signOut();

      //Auth.federatedSignIn();
    } catch (error) {
      console.error("Error signing out:", error);
      throw error;
    }
  }

  static async currentAuthenticatedUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      return user;
    } catch (error) {
      console.error("Error getting current authenticated user:", error);
      throw error;
    }
  }

  static async currentSession() {
    try {
      const session = await Auth.currentSession();
      return session;
    } catch (error) {
      console.error("Error getting current session:", error);
      throw error;
    }
  }

  static async currenUserGroup() {
    try {
      const user = await Auth.currentSession();
      const role = user.getAccessToken().payload["cognito:groups"];
      return role[0];
    } catch (err) {
      console.error("Error on fetching user group");
      throw err;
    }
  }
}
export default AuthService;
